import Icon from '../components/Icon.vue'

Icon.register({"step-forward":{"width":1024,"height":1792,"paths":[{"d":"M45 1651q-19 19-32 13t-13-32v-1472q0-26 13-32t32 13l710 710q9 9 13 19v-678q0-26 19-45t45-19h128q26 0 45 19t19 45v1408q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-678q-4 10-13 19z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/step-forward.js
// module id = 1115
// module chunks = 0